import ProfileVerificationStatusCd from 'domain/enums/ProfileVerificationStatusCd';
import VerificationStatus from './VerificationStatus';

/**
 *
 * @param status If available, the status of the uploaded document.
 * @param hasUploaded True if the user has uploaded a document.
 * @param hasSubmittedApp True if the user has submitted an application.
 */
export default function getVerificationStatus(
  status: ProfileVerificationStatusCd | null,
  hasUploaded: boolean,
  hasSubmittedApp: boolean
): VerificationStatus | null {
  if (status !== null) {
    switch (status) {
      case ProfileVerificationStatusCd.PENDING:
        return VerificationStatus.pending;
      case ProfileVerificationStatusCd.REJECTED:
        return VerificationStatus.denied;
      case ProfileVerificationStatusCd.APPROVED:
        return VerificationStatus.approved;
    }
  }
  if (!hasUploaded) {
    return VerificationStatus.noDocuments;
  }

  if (!hasSubmittedApp) {
    return VerificationStatus.noApplications;
  }

  return null;
}
